import { AccessControl } from '../components';
import NotificationLayout from '../components/NotificationSSE/components/NotificationLayout';
import NotificationSSE from '../components/NotificationSSE/NotificationSSE';
import PageRemoved from '../components/PageRemoved';
import { default as PermissionContextProvider } from '../context/PermissionContext/PermissionContext';
import AccessControlListing from '../features/accessControl/AccessControlListing';
import ATSCustomAccessControl from '../features/accessControl/ATSCustomAccessControl';
import ClientContactsAccessControl from '../features/accessControl/ClientContactsAccessControl';
import ClientListingAccess from '../features/accessControl/ClientListingAccess';
import ComposableAnalyticsAccessControl from '../features/accessControl/ComposableAnalyticsAccessControl';
import CrmJobsAccessControl from '../features/accessControl/CrmJobsAccessControl';
import CustomListingAccess from '../features/accessControl/CustomListingAccess';
import EntityAccessControl from '../features/accessControl/EntityListingAccessControl';
import { AccessContolBreadCrumbListAndTitle } from '../features/accessControl/helper';
import InvoicingAndClosureAccess from '../features/accessControl/InvoicingAndClosureAccess';
import LeadAccessControl from '../features/accessControl/LeadAccessControl';
import { ActiveConsultantsRoutes } from '../features/activeConsultants/routes';
import ActivityLogRoutes from '../features/activityLog/routes';
import ComposableDashboardContextProvider from '../features/analyticsPage/context/ComposableDashboardContext';
import ComposableDashboardFiltersContextProvider from '../features/analyticsPage/context/ComposableDashboardFiltersContext';
import ComposableDashboardsCollectionsContextProvider from '../features/analyticsPage/context/ComposableDashboardsCollectionContext';
import ComposableDynamicListingContextProvider from '../features/analyticsPage/context/ComposableDynamicListingContext';
import { AnalyticsSettingsRoutes } from '../features/analyticsSettings';
import { FAQsRoutes } from '../features/appsettings/components/faqs';
import { AppSettingsRoutes } from '../features/appsettings/routes';
import { AutomatedEmailCampaignRoutes } from '../features/automatedEmailCampaignSettings';
import { AutomationFlowRoutes } from '../features/AutomationSettings/routes';
import { BulkImporterAppRoutes } from '../features/bulkImporterApp/routes';
import { CalenderAccountsRoutes } from '../features/calenderEvent';
import { CallLogs } from '../features/callLogs';
import CandidateJobBoardProfile from '../features/candidateJobBoardProfile/components/CandidateJobBoardProfile';
import { CandidateLayOutRoutes } from '../features/candidateLayout/routes';
import { CandidatesRoutes } from '../features/candidates/routes';
import { JobBoardSearchRoutes } from '../features/CandidateSearch/routes';
import { CareerPageSettingRoutes } from '../features/careerPageSettings/routes';
import ContactsRoutes from '../features/clientContacts/routes';
import ClientDetails from '../features/clientDetails';
import ClientContactDetails from '../features/clientDetails/components/clientContactsTab/ClientContactDetails';
import ClientListingRoutes from '../features/clientListingPage';
import {
  BusinessUnitSettings,
  CurrencyDetailsSettings,
  FeeArrangementLevelSettings,
  FileCategoriesSettings,
  OrganizationalUnitSettings,
} from '../features/clientsSettings/components';
import BusinessUnitUsersView from '../features/clientsSettings/components/BusinessUnitUsersView';
import ClientUnits from '../features/clientsSettings/components/ClientUnits';
import LegalIdentifierSettings from '../features/clientsSettings/components/LegalIdentifierSettings';
import OrganizationalUnitView from '../features/clientsSettings/components/OrganizationalUnitView';
import { ClientsSettingsRoutes } from '../features/clientsSettings/routes';
import CrmJobSettings from '../features/crmJobs/components/CrmJobSettings';
import { CrmJobStatus } from '../features/crmJobs/components/crmJobStatus';
import CRMJobsRoutes from '../features/crmJobs/routes';
import {
  CrmConfigSubmissionRoutes,
  PaginationSettingsRoutes,
  EvaluationTemplateRoute,
  RTRTemplateRoute,
  InformationCategoriesRoute,
  DataDownloadSettingsRoutes,
  StageStatusRoutes,
  ManageRecruiterActionRoute,
  ManageCandidateResponseRoute,
  RevenueCalculator,
} from '../features/crmSettings';
import { CVUploaderSettingRoutes } from '../features/CVUploaderCTASettings/routes';
import DataDownload from '../features/dataDownload/DataDownload';
import { DataProtectionRoutes } from '../features/dataProtection';
import { DataProtectionSetupRoutes } from '../features/dataProtectionSetup';
import DataSharing from '../features/dataSharing/DataSharing';
import { DeleteRequestsPageRoutes } from '../features/deleteRequests';
import { EmailSettings } from '../features/emailSettings';
import ExtensionLogin from '../features/extension/components';
import { ExtensionMappingRoutes } from '../features/extensionMappings/routes';
import { HelpAndKnowledgeRoutes } from '../features/helpAndKnowledgePage/components/routes';
import { HomePage } from '../features/home';
import { ImportCandidatesRoutes } from '../features/importCandidates/routes';
import { ConsultantsRoutes } from '../features/importConsultants';
import { UnifiedSearchRoutes } from '../features/integratedSearch/routes';
import { InvoicingRoutes } from '../features/invoicing/routes';
import { JobBoardRoutes } from '../features/jobBoardSettings/components/routes';
import { JobsRoutes } from '../features/jobs/routes';
import { JobsCrmRoutes } from '../features/jobsCrm/routes';
import {
  CustomizeJobFieldsRoutes,
  JobClosingPageRoutes,
  JobPostingSettingsRoutes,
  JobAttrVisibilityRoutes,
} from '../features/jobSettings';
import CustomizeJobCategoryDialog from '../features/jobSettings/customizeJobFields/CustomizeJobCategoryDialog';
import JobDataDownloadSettingsRoutes from '../features/jobSettings/dataDownloadSettings/routes';
import LeadsRoutes from '../features/leads/routes';
import { ShareCreditsRoutes } from '../features/massMailingCredits';
import { NativeSearchRoutes } from '../features/nativeSearch/routes';
import { NativeSearchSettingsRoutes } from '../features/nativeSearchSettings/components/routes';
import NotesRoutes from '../features/notes/routes';
import { NotificationPageRoutes } from '../features/notificationSettings';
import { OnBoardingRoutes } from '../features/onBoarding/routes';
import { OurEntityRoute } from '../features/ourEntity';
import { PaymentRoutes } from '../features/paymentFlow/routes';
import PrismSettings from '../features/prismSettings/PrismSettings';
import PrismUserManagement from '../features/prismSettings/PrismUserManagement';
import SessionSettings from '../features/prismSettings/SessionManagement';
import { PrismSettingsRoutes } from '../features/prismSettingsPage/routes';
import { PrivateExtensionRoutes } from '../features/privateExtensionPage/routes';
import { PromptSettingRoutes } from '../features/promptSettingsPage/routes';
import { RecruiterProfileRoutes } from '../features/recruiterProfileDetails/components/routes';
import Profile from '../features/recruiterProfileDetails/components/userProfile/Profile';
import { ResumeParsingByEmailPage } from '../features/resumeParsingByEmailPage/resumeParsingByEmail';
import EmailsSettings from '../features/resumeParsingByEmailPage/resumeParsingByEmail/EmailsSettings';
import { emailSettingsProps } from '../features/resumeParsingByEmailPage/utils/helper';
import SMSConfiguration from '../features/smsConfiguration/SMSConfiguration';
import { SmsLogs } from '../features/smsLogs';
import { SubmissionRoutes } from '../features/submissions/routes';
import { SubmissionsNewRoutes } from '../features/submissionsNew/routes';
import { TaskRoutes } from '../features/tasks/routes';
import TeamMemberAndAnalyticsView from '../features/teams/components/TeamMemberAndAnalyticsView';
import { TeamRoutes } from '../features/teams/routes';
import { TemplateSettingsRoutes } from '../features/templateSettings';
import AccountManagerDetailsPage from '../features/users/components/AccountManagerDetailsPage';
import { TeamsAndUsersRoutes, UserRoutes } from '../features/users/routes';
import { VendorsRoutes } from '../features/vendors/routes';
import VendorListingRoutes from '../features/vendorslist';
import { VmsRoutes } from '../features/vms/routes';
import { WorkspaceListing } from '../features/workspace';
import { WorkspaceSettingRoutes } from '../features/workspaceSettings/routes';

import RouteGuard from './RouteGuard';
import RouteWithTitle from './RouteWithTitle';

export const protectedRoutes = [
  {
    path: '/*',
    element: (
      <RouteGuard>
        <HomePage />
      </RouteGuard>
    ),
  },
  {
    path: '/app-settings/*',
    element: (
      <RouteGuard>
        <AppSettingsRoutes />
      </RouteGuard>
    ),
  },
  {
    path: '/workspace/*',
    element: (
      <RouteGuard>
        <WorkspaceListing />
      </RouteGuard>
    ),
  },
  {
    path: '/jobs/*',
    element: <JobsRoutes />,
  },
  {
    path: '/job-boards/*',
    element: <JobBoardRoutes />,
  },
  {
    path: '/vendors/*',
    element: <VendorsRoutes />,
  },
  {
    path: '/notification-settings/*',
    element: <NotificationPageRoutes />,
  },

  {
    path: '/job-fields-settings/*',
    element: <CustomizeJobFieldsRoutes />,
  },
  {
    path: '/jobs-download-settings/*',
    element: <JobDataDownloadSettingsRoutes />,
  },
  {
    path: '/close-job-reason/*',
    element: <JobClosingPageRoutes />,
  },
  {
    path: '/job-posting-settings/*',
    element: <JobPostingSettingsRoutes />,
  },
  {
    path: '/job-attribute-visibility-setting/*',
    element: <JobAttrVisibilityRoutes />,
  },
  {
    path: '/teams/*',
    element: <TeamRoutes />,
  },
  {
    path: '/users/*',
    element: <UserRoutes />,
  },
  {
    path: '/workspace-users-and-teams/*',
    element: (
      <ComposableDynamicListingContextProvider>
        <ComposableDashboardContextProvider>
          <ComposableDashboardsCollectionsContextProvider>
            <TeamsAndUsersRoutes />
          </ComposableDashboardsCollectionsContextProvider>
        </ComposableDashboardContextProvider>
      </ComposableDynamicListingContextProvider>
    ),
  },
  {
    path: '/app-settings/career-page/*',
    element: (
      <RouteWithTitle title="Career Page - Wisestep">
        <CareerPageSettingRoutes />
      </RouteWithTitle>
    ),
  },
  {
    path: '/email-settings/*',
    element: <EmailSettings />,
  },
  {
    path: '/data-sharing/',
    element: (
      <RouteWithTitle title="Data Sharing- Wisestep">
        <DataSharing />
      </RouteWithTitle>
    ),
  },
  {
    path: '/data-download/*',
    element: (
      <RouteWithTitle title="Data Download - Wisestep">
        <DataDownload />
      </RouteWithTitle>
    ),
  },
  {
    path: '/analytics-settings/*',
    element: <AnalyticsSettingsRoutes />,
  },
  {
    path: '/calender-settings/*',
    element: <CalenderAccountsRoutes />,
  },
  {
    path: '/vendors/mailing-credits/*',
    element: <ShareCreditsRoutes />,
  },
  {
    path: '/crm-settings/*',
    element: <CrmConfigSubmissionRoutes />,
  },
  {
    path: '/pagination-settings/*',
    element: <PaginationSettingsRoutes />,
  },
  {
    path: '/evaluation-template/*',
    element: <EvaluationTemplateRoute />,
  },
  {
    path: '/rtr-template/*',
    element: <RTRTemplateRoute />,
  },
  { path: '/contract_revenue_calculator', element: <RevenueCalculator /> },
  {
    path: '/information-categories/*',
    element: <InformationCategoriesRoute />,
  },
  {
    path: '/download-settings/*',
    element: <DataDownloadSettingsRoutes />,
  },
  {
    path: '/download-settings/*',
    element: <DataDownloadSettingsRoutes />,
  },

  {
    path: '/candidate-stage-status-pipeline-settings/*',
    element: <StageStatusRoutes />,
  },
  {
    path: '/candidates/*',
    element: <CandidatesRoutes />,
  },
  {
    path: '/submissions/*',
    element: <SubmissionRoutes />,
  },
  {
    path: '/consultant/*',
    element: <ConsultantsRoutes />,
  },
  {
    path: '/sms-configuration',
    element: (
      <RouteWithTitle title="SMS Configuration- Wisestep">
        <SMSConfiguration />
      </RouteWithTitle>
    ),
  },
  {
    path: '/template-settings/*',
    element: <TemplateSettingsRoutes />,
  },
  {
    path: '/prism-extension-settings',
    element: (
      <RouteWithTitle title="Prism Extension Settings- Wisestep">
        <PrismSettings />
      </RouteWithTitle>
    ),
  },
  {
    path: '/prism-user-management/',
    element: (
      <RouteWithTitle title="Prism Extension User Management Settings- Wisestep">
        <PrismUserManagement />
      </RouteWithTitle>
    ),
  },
  {
    path: '/prism-session-management/',
    element: (
      <RouteWithTitle title="Prism Extension User Management Settings- Wisestep">
        <SessionSettings />
      </RouteWithTitle>
    ),
  },
  {
    path: '/candidate-interaction-messaging/*',
    element: <ManageRecruiterActionRoute />,
  },
  { path: '/recruiter/*', element: <RecruiterProfileRoutes /> },
  { path: '/native-search/*', element: <NativeSearchRoutes /> },
  { path: '/native-search-new/*', element: <JobBoardSearchRoutes /> },
  {
    path: '/active-consultants/*',
    element: <ActiveConsultantsRoutes />,
  },
  {
    path: '/jobs-crm/*',
    element: <JobsCrmRoutes />,
  },
  { path: '/native-search-settings/*', element: <NativeSearchSettingsRoutes /> },
  {
    path: '/candidate-interaction-result-pipeline/*',
    element: <ManageCandidateResponseRoute />,
  },
  {
    path: '/onboarding/*',
    element: <OnBoardingRoutes />,
  },
  {
    path: '/sms-logs',
    element: <SmsLogs />,
  },
  {
    path: '/call-logs',
    element: <CallLogs />,
  },
  {
    path: '/import-candidates/*',
    element: <ImportCandidatesRoutes />,
  },
  {
    path: '/access-control/',
    element: (
      <PermissionContextProvider>
        <AccessControlListing />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/ats-access-control/',
    element: (
      <PermissionContextProvider>
        <CustomListingAccess
          module="ATS_ACCESS"
          url=""
          titleAndBreadCrumbs={AccessContolBreadCrumbListAndTitle['ATS_ACCESS']}
        />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/native-search-access-control/',
    element: (
      <PermissionContextProvider>
        <CustomListingAccess
          module="NATIVE_SEARCH"
          url="candidatesearch"
          titleAndBreadCrumbs={AccessContolBreadCrumbListAndTitle['NATIVE_SEARCH_ACEESS']}
        />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/premium-job-access-control/',
    element: (
      <PermissionContextProvider>
        <CustomListingAccess
          module="PREMIUM_JOB"
          url="jobsearch"
          titleAndBreadCrumbs={AccessContolBreadCrumbListAndTitle['PREMIUM_JOB_BOARDS_ACCESS']}
        />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/jobs-access-control/',
    element: (
      <PermissionContextProvider>
        <CustomListingAccess
          module="JOB_BOARD"
          url="jobsearch"
          titleAndBreadCrumbs={AccessContolBreadCrumbListAndTitle['JOBS_ACCESS']}
        />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/candidate-access-control/',
    element: (
      <PermissionContextProvider>
        <CustomListingAccess
          module="CANDIDATE_BOARD"
          url="candidatesearch"
          titleAndBreadCrumbs={AccessContolBreadCrumbListAndTitle['CANDIDATE_ACCESS']}
        />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/attributes-visibility/',
    element: (
      <PermissionContextProvider>
        <CustomListingAccess
          module="ATTRIBUTES_VISIBILITY"
          url=""
          titleAndBreadCrumbs={AccessContolBreadCrumbListAndTitle['ATTRIBUTE_VISIBILITY']}
        />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/vms-access-control/',
    element: (
      <PermissionContextProvider>
        <CustomListingAccess
          module="VMS_CONFIGURATION"
          url="jobsearch"
          titleAndBreadCrumbs={AccessContolBreadCrumbListAndTitle['VMS_ACCESS']}
        />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/users-access-control/',
    element: (
      <PermissionContextProvider>
        <CustomListingAccess
          module="USERS_ACCESS"
          url=""
          titleAndBreadCrumbs={AccessContolBreadCrumbListAndTitle['USER_ACCESS']}
        />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/teams-access-control/',
    element: (
      <PermissionContextProvider>
        <CustomListingAccess
          module="TEAMS_ACCESS"
          url=""
          titleAndBreadCrumbs={AccessContolBreadCrumbListAndTitle['TEAMS_ACCESS']}
        />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/ats-custom-control/',
    element: (
      <PermissionContextProvider>
        <ATSCustomAccessControl />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/sms-access-control/',
    element: (
      <PermissionContextProvider>
        <CustomListingAccess
          module="SMS_CONFIGURATION"
          url="communicationservice"
          titleAndBreadCrumbs={AccessContolBreadCrumbListAndTitle['SMS_ACCESS']}
        />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/client-listing-access-control/',
    element: (
      <PermissionContextProvider>
        <ClientListingAccess />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/lead-access-control/',
    element: (
      <PermissionContextProvider>
        <LeadAccessControl />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/crm-jobs-access-control/',
    element: (
      <PermissionContextProvider>
        <CrmJobsAccessControl />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/client-contacts-access-control/',
    element: (
      <PermissionContextProvider>
        <ClientContactsAccessControl />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/invoicing-closure-access-control/',
    element: (
      <PermissionContextProvider>
        <InvoicingAndClosureAccess />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/entity-access-control/',
    element: (
      <PermissionContextProvider>
        <EntityAccessControl />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/analytics-data-access-control/',
    element: (
      <PermissionContextProvider>
        <ComposableAnalyticsAccessControl />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/tasks/*',
    element: <TaskRoutes />,
  },
  {
    path: '/notification',
    element: <NotificationLayout />,
  },
  {
    path: '/notification/sse',
    element: <NotificationSSE />,
  },
  {
    path: '/private-extension',
    element: <PrivateExtensionRoutes />,
  },
  {
    path: '/resume-parsing-by-email',
    element: <ResumeParsingByEmailPage />,
  },
  {
    path: '/prism-download/*',
    element: <PrismSettingsRoutes />,
  },
  {
    path: '/bulk-importer',
    element: <BulkImporterAppRoutes />,
  },
  // {
  //   path: '/configure-email-inbox',
  //   element: <ConfigureEmailSync />,
  // },
  {
    path: '/currencies',
    element: <CurrencyDetailsSettings />,
  },
  {
    path: '/app-settings/file_categories',
    element: <FileCategoriesSettings />,
  },
  {
    path: '/business_unit',
    element: <BusinessUnitSettings />,
  },
  {
    path: '/organizational_unit',
    element: <OrganizationalUnitSettings />,
  },
  {
    path: '/business_unit/user-view',
    element: (
      <ComposableDynamicListingContextProvider>
        <ComposableDashboardContextProvider>
          <ComposableDashboardsCollectionsContextProvider>
            <ComposableDashboardFiltersContextProvider>
              <BusinessUnitUsersView />
            </ComposableDashboardFiltersContextProvider>
          </ComposableDashboardsCollectionsContextProvider>
        </ComposableDashboardContextProvider>
      </ComposableDynamicListingContextProvider>
    ),
  },
  {
    path: '/team/team-members-view',
    element: (
      <ComposableDynamicListingContextProvider>
        <ComposableDashboardContextProvider>
          <ComposableDashboardsCollectionsContextProvider>
            <ComposableDashboardFiltersContextProvider>
              <TeamMemberAndAnalyticsView />
            </ComposableDashboardFiltersContextProvider>
          </ComposableDashboardsCollectionsContextProvider>
        </ComposableDashboardContextProvider>
      </ComposableDynamicListingContextProvider>
    ),
  },
  {
    path: '/organizational_unit/user-view',
    element: (
      <ComposableDynamicListingContextProvider>
        <ComposableDashboardContextProvider>
          <ComposableDashboardsCollectionsContextProvider>
            <ComposableDashboardFiltersContextProvider>
              <OrganizationalUnitView />
            </ComposableDashboardFiltersContextProvider>
          </ComposableDashboardsCollectionsContextProvider>
        </ComposableDashboardContextProvider>
      </ComposableDynamicListingContextProvider>
    ),
  },
  {
    path: '/position_levels',
    element: <FeeArrangementLevelSettings />,
  },
  {
    path: '/notes-email',
    element: <EmailsSettings {...emailSettingsProps.notes} />,
  },
  {
    path: '/leads-email',
    element: <EmailsSettings {...emailSettingsProps.leads} />,
  },
  {
    path: '/legal_identifiers',
    element: <LegalIdentifierSettings />,
  },
  {
    path: '/client-settings',
    element: <ClientsSettingsRoutes />,
  },
  {
    path: '/data-protection/*',
    element: <DataProtectionRoutes />,
  },
  {
    path: '/all-submissions',
    element: (
      <PermissionContextProvider>
        <SubmissionsNewRoutes />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/automated-email-campaign-settings/*',
    element: <AutomatedEmailCampaignRoutes />,
  },
  {
    path: '/vms/*',
    element: <VmsRoutes />,
  },
  {
    path: '/delete-requests/*',
    element: <DeleteRequestsPageRoutes />,
  },
  {
    path: '/client-details',
    element: (
      <PermissionContextProvider>
        <ComposableDynamicListingContextProvider>
          <ComposableDashboardContextProvider>
            <ComposableDashboardsCollectionsContextProvider>
              <ClientDetails />
            </ComposableDashboardsCollectionsContextProvider>
          </ComposableDashboardContextProvider>
        </ComposableDynamicListingContextProvider>
      </PermissionContextProvider>
    ),
  },
  {
    path: '/:id/client-contact-details',
    element: (
      <PermissionContextProvider>
        <ComposableDynamicListingContextProvider>
          <ComposableDashboardContextProvider>
            <ComposableDashboardsCollectionsContextProvider>
              <ClientContactDetails />
            </ComposableDashboardsCollectionsContextProvider>
          </ComposableDashboardContextProvider>
        </ComposableDynamicListingContextProvider>
      </PermissionContextProvider>
    ),
  },
  {
    path: '/clients/*',
    element: (
      <PermissionContextProvider>
        <ClientListingRoutes />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/crm-jobs/*',
    element: (
      <PermissionContextProvider>
        <CRMJobsRoutes />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/automation/*',
    element: (
      // <PermissionContextProvider>
      <AutomationFlowRoutes />
      // </PermissionContextProvider>
    ),
  },
  {
    path: '/leads/*',
    element: (
      <PermissionContextProvider>
        <LeadsRoutes />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/vendorslist/*',
    element: (
      <PermissionContextProvider>
        <VendorListingRoutes />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/note-list/*',
    element: (
      <PermissionContextProvider>
        <NotesRoutes />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/activitylog-list/*',
    element: (
      <PermissionContextProvider>
        <ActivityLogRoutes />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/contacts-list/*',
    element: (
      <PermissionContextProvider>
        <ContactsRoutes />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/client-units',
    element: (
      <PermissionContextProvider>
        <ClientUnits title="Client Units" scopeType="Clients" />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/client-contacts-units',
    element: (
      <PermissionContextProvider>
        <ClientUnits title="Client Contacts Units" scopeType="Client Contacts" />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/setup',
    element: <DataProtectionSetupRoutes />,
  },
  {
    path: '/placements/*',
    element: <PageRemoved />,
  },
  {
    path: '/organisationEntity/*',
    element: <OurEntityRoute />,
  },
  {
    path: '/extensionmapping*',
    element: <ExtensionMappingRoutes />,
  },
  {
    path: '/workspace-settings/*',
    element: <WorkspaceSettingRoutes />,
  },
  {
    path: '/invoice*',
    element: (
      <PermissionContextProvider>
        <InvoicingRoutes />
      </PermissionContextProvider>
    ),
  },
  {
    path: '/payment_type',
    element: <InvoicingRoutes />,
  },
  {
    path: '/tax_type',
    element: <InvoicingRoutes />,
  },
  {
    path: '/invoice_type',
    element: <InvoicingRoutes />,
  },
  {
    path: '/plan/*',
    element: <PaymentRoutes />,
  },
  {
    path: '/extension/*',
    element: <ExtensionLogin />,
  },
  {
    path: '/help-and-knowledge/*',
    element: <HelpAndKnowledgeRoutes />,
  },
  {
    path: '/cv-view-analytics-bar-charts',
    element: <>This Url is Removed</>,
  },
  {
    path: '/faqs/*',
    element: <FAQsRoutes />,
  },
  {
    path: '/app-settings/cv-upload-settings/*',
    element: (
      <RouteWithTitle title="CV uploader settings - Wisestep">
        <CVUploaderSettingRoutes />
      </RouteWithTitle>
    ),
  },

  {
    path: '/Access-denied',
    element: (
      <RouteGuard>
        <AccessControl />
      </RouteGuard>
    ),
  },
  {
    path: '/candidate-job-board-profile',
    element: (
      <RouteGuard>
        <CandidateJobBoardProfile />
      </RouteGuard>
    ),
  },
  {
    path: '/job-category-configuration',
    element: (
      <RouteGuard>
        <CustomizeJobCategoryDialog />
      </RouteGuard>
    ),
  },
  {
    path: 'candidate-layout/*',
    element: <CandidateLayOutRoutes />,
  },
  {
    path: '/account-manager/details-page',
    element: (
      <ComposableDynamicListingContextProvider>
        <ComposableDashboardContextProvider>
          <ComposableDashboardsCollectionsContextProvider>
            <ComposableDashboardFiltersContextProvider>
              <AccountManagerDetailsPage />
            </ComposableDashboardFiltersContextProvider>
          </ComposableDashboardsCollectionsContextProvider>
        </ComposableDashboardContextProvider>
      </ComposableDynamicListingContextProvider>
    ),
  },
  {
    path: '/users/details-page',
    element: (
      <ComposableDynamicListingContextProvider>
        <ComposableDashboardContextProvider>
          <ComposableDashboardsCollectionsContextProvider>
            <ComposableDashboardFiltersContextProvider>
              <Profile />
            </ComposableDashboardFiltersContextProvider>
          </ComposableDashboardsCollectionsContextProvider>
        </ComposableDashboardContextProvider>
      </ComposableDynamicListingContextProvider>
    ),
  },
  {
    path: '/prompt-settings/*',
    element: <PromptSettingRoutes />,
  },
  {
    path: '/new-search/*',
    element: <UnifiedSearchRoutes />,
  },
  {
    path: '/crm-job-settings',
    element: <CrmJobSettings />,
  },
  {
    path: '/crm-job-status',
    element: <CrmJobStatus />,
  },
];
